import { render, staticRenderFns } from "./ZxCountDown.vue?vue&type=template&id=5983aa04&scoped=true"
import script from "./ZxCountDown.vue?vue&type=script&lang=js"
export * from "./ZxCountDown.vue?vue&type=script&lang=js"
import style0 from "./ZxCountDown.vue?vue&type=style&index=0&id=5983aa04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983aa04",
  null
  
)

export default component.exports